import AssessmentIcon from "@mui/icons-material/Assessment";
import Navigation from "Layouts/SideNavigation/Navigation";
import {
    IItemOptions,
    INavigation,
} from "Layouts/SideNavigation/NavigationStore";
import { observer } from "mobx-react";
import React from "react";
import hexToRGB from "utils/hexToRGB";
import { useStore } from "utils/useStore";
import WorkflowsNavigationStore, {
    WorkflowsPage,
} from "../Stores/WorkflowsNavigationStore";
import theme from "Theme/FocusTheme";

type Props = {};

const itemOptions: IItemOptions = {
    itemSpacing: "spread",
    autoSelectOrg: true,
};

const WorkflowsNavigation: React.FC<Props> = observer(() => {
    const store = useStore(WorkflowsNavigationStore);

    React.useEffect(() => {
        const items: INavigation[] = [
            {
                title: "Workflow Aging",
                link:
                    store.WORKFLOWS_ROUTE_PREFIX +
                    WorkflowsPage.WORKFLOWS_AGING.toString(),
                icon: (
                    <AssessmentIcon
                        sx={{ color: hexToRGB(theme.palette.black.main, 0.8) }}
                    />
                ),
                selectedIcon: <AssessmentIcon color="secondary" />,
                defaultRoute: true,
            },
        ];

        store.navStore.setNavItems(items);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store.WORKFLOWS_ROUTE_PREFIX, store.navStore]);

    return <Navigation store={store.navStore} itemOptions={itemOptions} />;
});

export default WorkflowsNavigation;
